import React from 'react';
import Pagination from 'rsuite/Pagination';
import MyLoader from '../../common/loader.component';
import {
  CleanCustomsDeliveryMethod,
  CleanCustomsDeliveryMethodMethod,
  CustomsDeliveryOrderStatus,
} from '../../../export-types/cleaned-types';
import { usePaginationQs } from '../../../utils/usePagination';
import { useSearchParamsPaginationEffect } from '../purchase-order/useSearchParamsPaginationEffect';
import { CustomsDeliveryOrderItem } from './customs-delivery-order-item';
import { trpcSwr } from '../../../api/trpc';
import { useOutletContext } from 'react-router-dom';
import { OutletContextParams } from '../delivery/delivery-orders-screen';
import { useSortingLocalStorage } from '../../../api/useSortingLocalStorage';
import {
  getDeliveryMethodIcon,
  getDeliveryPeriod,
} from '../../../utils/common.utils';

type Props = {
  status: CustomsDeliveryOrderStatus;
};

export const CustomsDeliveryOrdersList = (props: Props) => {
  const { sortValues } = useSortingLocalStorage();

  const { take, skip, handleSetPage, handleChangeLimit, page } =
    usePaginationQs(15);

  useSearchParamsPaginationEffect(handleSetPage);
  const { debouncedInternalId } = useOutletContext<OutletContextParams>();

  const { data, error, isLoading } = trpcSwr.customsDelivery.listOrders.useSWR({
    statuses: [props.status],
    take,
    skip,
    searchValue: debouncedInternalId,
    sortDirection: sortValues.direction,
    linked: sortValues.linked,
  });

  if (isLoading) {
    return (
      <>
        <div className="pb-4">
          <MyLoader />
        </div>
      </>
    );
  }

  if (error || !data) {
    return (
      <>
        <div className="pb-4">Неизвестная ошибка</div>
      </>
    );
  }

  return (
    <>
      <div className="pb-4">
        {data.items.map((data) => (
          <CustomsDeliveryOrderItem key={data.id} data={data} />
        ))}
      </div>
      {data.total > take && (
        <div className="pb-4">
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="md"
            layout={['pager']}
            total={data?.total}
            limitOptions={[15, 20]}
            limit={take}
            activePage={page}
            onChangePage={handleSetPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
      )}
    </>
  );
};
